module.exports = __webpack_public_path__ + "img/sheep.83e90a0a.png";